<template>
<div class="top_header">
  <div class="width_auto flexr justify_between align_center">
    <img @click="$router.push('/')" src="@/assets/logo/logo.png" alt="logo" class="top_header_logo" />
    <ul class="top_header_menu flexr">
      <li><router-link to="/" :class="{'router-active':activeIndex=='Index'}">网站首页</router-link></li>
      <li>
        <el-dropdown @command="handleCommand">
          <router-link v-if="grupList.length&&grupList.length>0" :to="`/group/${grupList[0].articleId}`" :class="{'router-active':activeIndex=='Group'}">集团概况</router-link>
          <router-link v-else :to="`/group`" :class="{'router-active':activeIndex=='Group'}">集团概况</router-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item,index) in grupList"  :key="index" :command="`/group/${item.articleId}`">{{ item.articleTitle }}</el-dropdown-item>
<!--            <el-dropdown-item command="/group/1">公司简介</el-dropdown-item>-->
<!--            <el-dropdown-item command="/group/1">领导成员</el-dropdown-item>-->
<!--            <el-dropdown-item command="/group/1">组织机构</el-dropdown-item>-->
<!--            <el-dropdown-item command="/group/1">企业文化</el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>
      </li>
      <li>
        <el-dropdown @command="handleCommand">
          <router-link v-if="newsClassifyList.length&&newsClassifyList.length>0" :to="`/news/${newsClassifyList[0].categoryId}`" :class="{'router-active':activeIndex=='News'}">新闻中心</router-link>
          <router-link v-else :to="`/news`" :class="{'router-active':activeIndex=='News'}">新闻中心</router-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item,index) in newsClassifyList" :key="index" :command="`/news/${item.categoryId}`">
              {{ item.categoryName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
      <li>
        <el-dropdown @command="handleCommand">
          <router-link v-if="buildClassify.length&&buildClassify.length>0" :to="`/partyBuilding/${buildClassify[0].categoryId}`" :class="{'router-active':activeIndex=='PartyBuilding'}">党建纪检</router-link>
          <router-link v-else :to="`/partyBuilding`" :class="{'router-active':activeIndex=='PartyBuilding'}">党建纪检</router-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item,index) in buildClassify" :key="index" :command="`/partyBuilding/${item.categoryId}`">
              {{ item.categoryName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>

<!--      <li>-->
<!--        <el-dropdown @command="handleCommand">-->
<!--          <router-link v-if="hrList.length&&hrList.length>0" :to="`/hr/${hrList[0].articleId}`" :class="{'router-active':activeIndex=='Hr'}">人力资源</router-link>-->
<!--          <router-link v-else :to="`/hr`" :class="{'router-active':activeIndex=='Hr'}">人力资源</router-link>-->
<!--          <el-dropdown-menu slot="dropdown">-->
<!--            <el-dropdown-item v-for="(item,index) in hrList"  :key="index" :command="`/hr/${item.articleId}`">{{ item.articleTitle }}</el-dropdown-item>-->
<!--&lt;!&ndash;            <el-dropdown-item command="/hr/1">人才培育</el-dropdown-item>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-dropdown-item command="/hr/2">人才引进</el-dropdown-item>&ndash;&gt;-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
<!--      </li>-->
      <li>
        <el-dropdown @command="handleCommand">
          <router-link v-if="noticeClassifyList.length&&noticeClassifyList.length>0" :to="`/notice/${noticeClassifyList[0].categoryId}`" :class="{'router-active':activeIndex=='Notice'}">公示公告</router-link>
          <router-link v-else :to="`/notice`" :class="{'router-active':activeIndex=='Notice'}">公示公告</router-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item,index) in noticeClassifyList" :key="index" :command="`/notice/${item.categoryId}`">{{ item.categoryName }}</el-dropdown-item>
<!--            <el-dropdown-item command="/notice/1">招标公告</el-dropdown-item>-->
<!--            <el-dropdown-item command="/notice/2">招商公告</el-dropdown-item>-->
<!--            <el-dropdown-item command="/notice/3">招租公告</el-dropdown-item>-->
<!--            <el-dropdown-item command="/notice/4">招聘公告</el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
    <HeaderSearch id="header-search" class="icon-top"></HeaderSearch>
  </div>
</div>
</template>

<script>
import HeaderSearch from "@/components/HeaderSearch";
import store from "@/store";

export default {
  name: "topHeader",
  components:{
    HeaderSearch,
  },
  data(){
    return {
      activeIndex:'Index',

    }
  },
  computed: {
    idCategory(){
      return store.state.idCategory||{}
    },
    newsClassifyList(){
      return store.state.newsClassify||[]
    },
    noticeClassifyList(){
      return store.state.noticeClassify||[]
    },
    grupList(){
      return store.state.grupList||[]
    },
    hrList(){
      return store.state.hrList||[]
    },
    buildClassify(){
      return store.state.buildClassify||[]
    },
  },

  watch:{
    $route(to, from){
      this.activeIndex = to.name
    }
  },

  mounted() {
    console.log(this.$route)
    this.activeIndex = this.$route.name
    //新闻中心
    store.dispatch('GetCategoryList',{parentId:this.idCategory.newsCP,type:'news'})
    store.dispatch('GetCategoryList',{parentId:this.idCategory.noticeCP,type:'notice'})
    store.dispatch('GetArticleList',{categoryId:this.idCategory.hrC,type:'hr'})
    store.dispatch('GetArticleList',{categoryId:this.idCategory.groupC,type:'group'})
    //党建纪检
    store.dispatch('GetCategoryList',{parentId:this.idCategory.djjjCP,type:'partyBuilding'})
  },
  methods: {
    handleCommand(command) {
      this.$router.push(command)
    }
  }
}
</script>

<style scoped lang="scss">
$top-header-height:72px;
::v-deep .el-dropdown-menu__item{
  font-size: 16px!important;
}
.top_header{
  height: $top-header-height;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  .width_auto{
    height: 100%;
  }
  .top_header_logo{
    height: 40px;
    width: auto;
    cursor: pointer;
  }
  .top_header_menu{
    margin-left: 4%;
    li{
      margin:0 30px;
      a{
        height: 30px;
        line-height: 30px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #202021;

        display: inline-block;
      }
      &:first-child{
        margin-left: 0;
      }
      &:last-child{
        margin-right: 0;
      }
    .router-active{
      position: relative;

      &:after{
        content: "";
        position: absolute;
        bottom: -5px;
        left: 0px;
        display: inline-block;
        width: 74px;
        height: 2px;
        background-color: #007aff;
      }
    }
    }
  }
}
.icon-top{
  width: 180px!important;
}

.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
  background-color: #2c89f1!important;
  color: #fff!important;
}
</style>
